import { InstanceDashboardStack } from 'component/navigation/instance';

export default function RankingEvalConversationSetLayout() {
    return <InstanceDashboardStack />;
}
